/**
* Call to Action JS
* -----------------------------------------------------------------------------
*
* All the JS for the Call to Action component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {gsap} from 'gsap';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'call-to-action',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      if ( window.hasMotion ) {
        const svgOne = document.querySelector( '.call-to-action__btn-circle-1 circle' );

        const tlOne = gsap.timeline( {paused: true} )
            .set( svgOne, {autoAlpha: 1} )
            .from( svgOne, {drawSVG: 0, ease: 'none'} );

        svgOne.onmouseenter = () => tlOne.play();
        svgOne.onmouseleave = () => tlOne.reverse();

        const svgTwo = document.querySelector( '.call-to-action__btn-circle-2 circle' );

        const tlTwo = gsap.timeline( {paused: true} )
            .set( svgTwo, {autoAlpha: 1} )
            .from( svgTwo, {drawSVG: 0, ease: 'none'} );

        svgTwo.onmouseenter = () => tlTwo.play();
        svgTwo.onmouseleave = () => tlTwo.reverse();
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'call-to-action', COMPONENT );
} )( app );
